import {CDR_DIALER as PREFIX} from '../../const';
import {ID} from '../../utils/helpers';
import {DEFAULT_PER_PAGE_DIALER} from '../../const';

const initialState = {
    loading: false,
    cdr_list: [],
    count: 0,
    page: 1,
    per_page: DEFAULT_PER_PAGE_DIALER,
    summaries: {},
};


const handlers = {
    ['SET_ITEMS_' + PREFIX]: (state, {payload: {cdr_full_list, cdr_full_count, cdr_full_summaries, page, per_page}}) => ({
        ...state,
        cdr_list: [
            ...cdr_full_list.map(x => {
                x.id = ID();
                return x;
            })
        ],
        loading: false,
        count: cdr_full_count,
        summaries: {
           ...cdr_full_summaries
        },
        page,
        per_page
    }),
    ['SET_LOADING_' + PREFIX]: (state, {payload}) => ({...state, loading: payload}),
    DEFAULT: state => state
};

export default (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action);
};
